import React, { useState, useMemo } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function MediaLightbox({ open, setOpen, media = [] }) {
  const [index, setIndex] = useState(0);

  // 🔹 Memoize slides to prevent ResizeObserver loops
  const slides = useMemo(() => {
    return media.map((item) =>
      item.media_type?.toLowerCase() === "video"
        ? {
            type: "video",
            poster: item.thumbnail_url || item.poster || "",
            sources: [
              {
                src: item.media_url,
                type: "video/mp4",
              },
            ],
          }
        : {
            type: "image",
            src: item.media_url,
          }
    );
  }, [media]);

  return (
    <Lightbox
      open={open}
      close={() => {
        setOpen(false);
        setIndex(0);
      }}

      index={index}
      on={{ view: ({ index }) => setIndex(index) }}

      slides={slides}

      // ✅ REQUIRED for video support
      plugins={[Video, Thumbnails, Zoom]}

      carousel={{ finite: false }}

      // 🔧 Zoom tuned to avoid resize loops
      zoom={{
        maxZoomPixelRatio: 2,
        zoomInMultiplier: 1.2,
        doubleTapDelay: 400,
        doubleClickDelay: 400,
      }}

      // 🔧 Thumbnails optimized (prevents ResizeObserver error)
      thumbnails={{
        position: "bottom",
        width: 120,
        height: 80,
        gap: 8,
        borderRadius: 8,
        hideWhenZoomed: true,
      }}
    />
  );
}

export default MediaLightbox;
